import React from 'react';
import cn from 'classnames';
import { formatUSD } from 'utils';

import styles from './USDAmount.module.css';

type USDAmountProps = {
  amount: number;
};

const USDAmount: React.FC<USDAmountProps> = ({ amount }) => {
  if (amount === 0) {
    return <>{'\u2013'}</>;
  }

  return (
    <span className={cn([amount > 0 && styles.green])}>
      {formatUSD(amount, { showPlusSign: true })}
    </span>
  );
};

export default USDAmount;
